module.exports = __webpack_public_path__ + "static/media/afgewerkt_white.52d36eb5.svg";